import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { SidebarNavContext } from "./SidebarNavContext";

export const useSidebarNav = () => {
  const context = useContext(SidebarNavContext);

  if (!context) {
    throw new HookOutOfContextError("useSidebarNav", "SidebarNavContext");
  }

  return context;
};
